import request from '@/utils/request'


export function getCourse(id,params) {
    return request({
      url: '/api/course_set/'+id+'/manage/base',
      method: 'get',
      params
    })
  }
  export function getCourseList(params) {
    return request({
      url: '/api/admin/course_set/normal/index',
      method: 'get',
      params
    })
  }
  //创建竞赛   course_set_manage_create
export function createCourse(data) {
  return request({
    url: '/api/course_set/create',
    method: 'post',
    data
  })
}

//更新课程
export function updateCourse(id,data) {
  return request({
    url: '/api/course_set/'+id+'/manage/base',
    method: 'post',
    data
  })
}

//删除课程
export function removeCourse(id) {
  return request({
    url: '/api/platform/course/'+id,
    method: 'delete',
  })
}

//检查课程
export function checkCourse(id) {
  return request({
    url: '/api/platform/course_check/'+id,
    method: 'put',
  })
}

//获取tag列表
export function searchTag(params) {
  return request({
    url: '/api/tag/match_jsonp',
    method: 'get',
    params
  })
}

//查找评委
export function searchTeacher(id,params) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/teachers_match',
    method: 'get',
    params
  })
}

//保存评委
export function updateTeachers(id,data) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/teachers',
    method: 'post',
    data
  })
}

//保存封面图片
export function updateCover(id,data) {
  return request({
    url: '/api/course_set/'+id+'/manage/cover_crop',
    method: 'post',
    data
  })
}

//检查是否有用户
export function checkCourseMember(id,params) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/students/check',
    method: 'get',
    params
  })
}

//添加参赛者
export function addCourseMember(id,data) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/students/add',
    method: 'post',
    data
  })
}

//获取竞赛参赛者
export function getCourseMemberList(id,params) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/students',
    method: 'get',
    params
  })
}

//获取竞赛参赛者审核列表
export function getCourseCheckMemberList(id,params) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/check_list',
    method: 'get',
    params
  })
}

//移除竞赛参赛者
export function removeCourseMember(id,studentId) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/students/'+studentId+'/remove',
    method: 'post'
  })
}


//获取竞赛退出参赛者
export function getCourseMemberQuitList(id,params) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/quit_records',
    method: 'get',
    params
  })
}

//通过竞赛参赛者申请
export function passCourseMember(id,studentId) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/students/'+studentId+'/pass',
    method: 'post'
  })
}

//拒绝竞赛参赛者申请
export function refuseCourseMember(id,studentId,data) {
  return request({
    url: '/api/course_set/'+id+'/manage/course/'+id+'/students/'+studentId+'/refuse',
    method: 'post',
    data
  })
}

//获取比赛页面
export function getContestIndex(code,params) {
  if(code){
    var url = "/api/course/explore/"+code;
  }else{
    var url = "/api/course/explore"
  }
  return request({
    url: url,
    method: 'get',
    params
  })
}

//发布竞赛  admin_course_set_publish
export function publishCompetition(id) {
  return request({
    url: '/api/course_set/'+id+'/manage/publish',
    method: 'post'
  })
}


//删除竞赛   admin_course_set_close
export function closeCompetition(id,params) {
  return request({
    url: '/api/admin/course_set/'+id+'/close',
    method: 'post',
    params
  })
}

//报名-不审核
export function applyCompetitions(params) {
  return request({
    url: '/api/order/show',
    method: 'post',
    params
  })
}

//报名-审核
export function applyCompetitionsCheck(id,data) {
  return request({
    url: '/api/competition/apply/'+id+'/check',
    method: 'post',
    data
  })
}

/**
 * 取消报名接口,调用edusoho方法
 * @param {*} data 
 * 【必填 competition_id targetType=course】
 */
export function cancleCompetition(data){
	return request({
      url: '/api/target/'+data['competition_id']+'/order/refund?targetType=course',
      method: 'post',
      data
  }) 
}

/**
 * 标签管理获取标签
 * @param {*} data 
 */
export function getTagData(data) {
  return request({
    url: '/api/admin/tag',
    method: 'post',
    data
  })
}

/**
 * 标签管理添加标签
 * @param {*} data 
 * 【必填 id name】
 */
export function addTagData(data) {
  return request({
    url: '/api/admin/tag/create',
    method: 'post',
    data
  })
}

/**
 * 标签管理编辑标签
 * @param {*} data 
 */
export function editTagData(id,data) {
  return request({
    url: '/api/admin/tag/'+id+'/update',
    method: 'post',
    data
  })
}

/**
 * 检查是否已存在标签名
 * @param {*} data 
 */
export function checkTagName(params) {
  return request({
    url: '/api/admin/tag/checkname',
    method: 'get',
    params
  })
}


/**
 * 标签管理删除标签
 * @param {*} data 
 */
export function deleteTagData(data) {
  return request({
    url: '/api/admin/tag/'+data['id']+'/delete',
    method: 'post',
    data
  })
}


/**
 * 标签管理获取标签组
 * @param {*} data 
 */
export function getTagGroupData(data) {
  return request({
    url: '/api/admin/tag/group',
    method: 'post',
    data
  })
}

/**
 * 标签组管理添加标签组
 * @param {*} data 
 */
export function addTagGroupData(data) {
  return request({
    url: '/api/admin/tag/group/create',
    method: 'post',
    data
  })
}

/**
 * 标签组管理编辑标签组
 * @param {*} data 
 */
export function editTagGroupData(id,data) {
  return request({
    url: '/api/admin/tag/group/'+id+'/update',
    method: 'post',
    data
  })
}

/**
 * 标签组管理编辑标签获取标签组下所有标签
 * @param {*} data 
 */
export function getTagsInGroup(data){
  return request({
    url: '/api/admin/tag/group/'+data['id']+'/getTags',
    method: 'post',
    data
  })
}

/**
 * 标签组管理加载所有标签
 * @param {*} data 
 * http://192.168.0.186:82/tag/match_jsonp?q=&page_limit=10&_=1578904766804
 */
export function loadAllTagsData(data){
  return request({
    url: '/api/admin/tag/match_jsonp',
    method: 'get',
    params
  })
}

/**
 * 检查标签组名称是否存在
 * @param {*} params 
 */
export function checkTagGroupName(params){
  return request({
    url: '/api/admin/tag/group/checkname',
    method: 'get',
    params
  })
}

/**
 * 标签组删除标签组
 * @param {*} data 
 */
export function deleteTagGroupData(data) {
  return request({
    url: '/api/admin/tag/group/'+data['id']+'/delete',
    method: 'post',
    data
  })
}

/**
 * 分类管理获取分类数据
 * @param {*} data 
 */
export function getCategoryData(type) {
  return request({
    url: '/api/admin/'+type+'/category',
    method: 'post',
  })
}

/**
 * 检查分类名称是否存在
 * @param {*} params 
 */
export function checkCategory(params){
  return request({
    url: '/api/admin/category/checkname',
    method: 'get',
    params
  })
}

/**
 * 分类管理创建新分类
 * @param {*} data 
 */
export function addCategory(data){
  return request({
    url: '/api/admin/category/create',
    method: 'post',
    data
  })
}

/**
 * 分类管理编辑分类
 * @param {*} data 
 */
export function editCategory(id,data){
  return request({
    url: '/api/admin/category/'+id+'/edit',
    method: 'post',
    data
  })
}

/**
 * 分类管理删除分类
 * @param {*} id 
 */
export function deleteCategory(id){
  return request({
    url: '/api/admin/category/'+id+'/delete',
    method: 'post',
  })
}

/**
 * 分类管理拖拽分类排序
 * @param {*} data 
 */
export function sortCategory(data){
  return request({
    url: '/api/admin/category/sort',
    method: 'post',
    data
  })
}


